// @flow
import React, { PureComponent } from 'react'
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Input, Textarea } from '../../../components/ui/forms';
import CountrySelect from './CountrySelect';

const Legend = styled.legend`
  font-size: 13px;
  color: white;
  margin: 20px 0;
`;

const FieldContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 5px;
  align-items: center;
`;

const FieldLeft = styled.div`
  flex: 0.5;
  text-align: right;
  margin-right: 10px;
  font-size: 14px;
`;

const FieldRight = styled.div`
  flex: 1;
`;

const Button = styled.button`
  color: white;
  display: block;
  padding: 10px;
  background: ${props => props.background};
  text-align: center;
  width: 100%;
  border: 1px solid rgba(0,0,0,0.5);
`;

const Form = styled.form`
  max-width: 600px;
  margin: 0 auto;
`;

const CountryGray = styled(CountrySelect)`
  background: #333;
`;

const Error = styled.div`
  color: red;
  font-size: 12px;
  
`;

class ContactForm extends PureComponent {
  state = {
    values: {},
    errors: {},
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const { values } = this.state;
    const errors = this.validate(values);
    this.setState({
      errors,
    });
    if (Object.keys(errors).length > 0) {
      return;
    }

  }

  validate = (values) => {
    const errors = {};
    if (!values.name) {
      errors.name = 'Campo requerido';
    }
    if (!values.country) {
      errors.country = 'Seleccione un País';
    }
    if (!values.city) {
      errors.city = 'Campo requerido';
    }
    if (!values.subject) {
      errors.subject = 'Campo requerido';
    }
    if (!values.msg) {
      errors.msg = 'Campo requerido';
    }
    if (!values.email) {
      errors.email = 'Campo requerido';
    }
    return errors;
  }

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      values: {
        ...this.state.values,
        [name]: value,
      }
    }, () => {
      const errors = this.validate(this.state.values);
      this.setState({
        errors,
      });
    });
  }

  props: {
    pageInfo: Object,
  }

  render() {
    const { errors } = this.state;
    return (
      <div>
        <Legend>Sus preguntas y comentarios son importantes para nosotros, lo invitamos a diligenciar el siguiente formulario.</Legend>
        <Form onSubmit={this.handleSubmit}>
          <FieldContainer>
            <FieldLeft>Nombre:</FieldLeft>
            <FieldRight>
              <Input hasError={errors.name} name="name" onChange={this.handleInputChange} />
              <Error show={errors.name}>{errors.name}</Error>
            </FieldRight>
          </FieldContainer>
          <FieldContainer>
            <FieldLeft>País:</FieldLeft>
            <FieldRight>
              <CountryGray name="country" onChange={this.handleInputChange} />
              <Error show={errors.country}>{errors.country}</Error>
            </FieldRight>
          </FieldContainer>
          <FieldContainer>
            <FieldLeft>Ciudad:</FieldLeft>
            <FieldRight>
              <Input hasError={errors.name} name="city" onChange={this.handleInputChange} />
              <Error show={errors.city}>{errors.city}</Error>
            </FieldRight>
          </FieldContainer>
          <FieldContainer>
            <FieldLeft>Teléfono Día:</FieldLeft>
            <FieldRight>
              <Input hasError={errors.name} name="phone" onChange={this.handleInputChange} />
              <Error show={errors.phone}>{errors.phone}</Error>
            </FieldRight>
          </FieldContainer>
          <FieldContainer>
            <FieldLeft>Teléfono Noche:</FieldLeft>
            <FieldRight>
              <Input name="phnnight" onChange={this.handleInputChange} />
            </FieldRight>
          </FieldContainer>
          <FieldContainer>
            <FieldLeft>Correo:</FieldLeft>
            <FieldRight>
              <Input hasError={errors.name} name="email" onChange={this.handleInputChange} />
              <Error show={errors.email}>{errors.email}</Error>
            </FieldRight>
          </FieldContainer>
          <FieldContainer>
            <FieldLeft>Asunto:</FieldLeft>
            <FieldRight>
              <Input hasError={errors.name} name="subject" onChange={this.handleInputChange} />
              <Error show={errors.subject}>{errors.subject}</Error>
            </FieldRight>
          </FieldContainer>
          <FieldContainer>
            <FieldLeft>Mensaje:</FieldLeft>
            <FieldRight>
              <Textarea rows="5" hasError={errors.name} name="msg" onChange={this.handleInputChange} />
              <Error show={errors.msg}>{errors.msg}</Error>
            </FieldRight>
          </FieldContainer>
          <FieldContainer>
            <FieldLeft />
            <FieldRight>
              <Button background={this.props.pageInfo && this.props.pageInfo.page.color_base}>Enviar información</Button>
            </FieldRight>
          </FieldContainer>
        </Form>
      </div>
    )
  }
}

export default connect(state => ({
  pageInfo: state.client.pageInfo,
}))(ContactForm);


// WEBPACK FOOTER //
// ./src/routes/Contact/ContactForm/index.js